
export enum SizeType {
  Small = 's',
  Middle = 'm',
  Large = 'l'
}
